import * as tslib_1 from "tslib";
import React from 'react';
import { connect } from 'formik';
/**
 * 上下文表单状态监听组件。
 *
 * @private
 * @export
 * @class FormStateMonitor
 * @extends {React.Component}
 */
var FormStateMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(FormStateMonitor, _super);
    function FormStateMonitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormStateMonitor.prototype.render = function () {
        var _a = this.props, action = _a.action, formik = _a.formik;
        formik.isValid = !Object.keys(formik.errors || {}).some(function (key) { return formik.errors[key]; });
        if (formik !== this.formik) {
            action(formik);
        }
        this.formik = formik;
        return null;
    };
    return FormStateMonitor;
}(React.Component));
export default connect(FormStateMonitor);
//# sourceMappingURL=FormStateMonitor.js.map